import { queryOptions } from '@tanstack/react-query';

import { getReport, getCuReportById } from '@/api';
import { QUERY_KEYS } from '@/constants';
import { ReportSaveMode } from '@/types';

export const getReportQuery = (offset: number, itemsPerPage: number, mode: ReportSaveMode | null) =>
  queryOptions({
    queryKey: [QUERY_KEYS.GET_REPORT, offset, itemsPerPage, mode],
    queryFn: () => getReport(offset, itemsPerPage, mode),
  });

export const getReportByIdQuery = (reportId?: number) =>
  queryOptions({
    queryKey: [QUERY_KEYS.GET_REPORT, reportId],
    queryFn: () => getCuReportById(reportId!),
    enabled: !!reportId,
    gcTime: 0,
    staleTime: 0,
    networkMode: 'online',
  });
